module.exports = __webpack_public_path__ + "img/icon-fenpei.5f8f5d2f.png";